import Car from "./Car";
import { useState, useEffect } from "react";

const Cars = () => {
  const [cars, setCars] = useState([]);

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await fetch("https://carbon-j654.onrender.com/api/cars");
        const cars = await response.json();
        setCars(cars);
      } catch (error) {
        console.error("Error fetching cars:", error);
      }
    };

    fetchCars();
  }, []);

  return (
    <div>
      <div className="flex justify-center items-center text-white text-4xl font-bold my-5">
        All Models
      </div>
      <Car cars={cars} isOrder={false} />
    </div>
  );
};

export default Cars;
